import { AxiosService } from './axios.service'

const baseURL = 'benefits'

/**
 * Defines the API methods for an benefits
 */
export class BenefitsService {
	/**
	 * Get benefits
	 * @return {Promise<any[]>}
	 */
	static GetBenefitsTypes() {
		return AxiosService.get(`${baseURL}`)
			.then(({ data }) => data)
			.catch(() => [])
	}

}
